export function getView(width) {
    let newView = 'MobileView';
    if (width > 1220) {
        newView = 'DesktopView';
    } else if (width > 767) {
        newView = 'TabView';
    }
    return newView;
}

export function getIsPC(width) {
    return width > 767; // 大于767px认为是PC端
}

const actions = {
    COLLPSE_CHANGE: 'COLLPSE_CHANGE',
    COLLPSE_OPEN_DRAWER: 'COLLPSE_OPEN_DRAWER',
    CHANGE_OPEN_KEYS: 'CHANGE_OPEN_KEYS',
    TOGGLE_ALL: 'TOGGLE_ALL',
    CHANGE_CURRENT: 'CHANGE_CURRENT',
    CLEAR_MENU: 'CLEAR_MENU',
    SET_VIEW_MODE: 'SET_VIEW_MODE',
    toggleCollapsed: () => ({
        type: actions.COLLPSE_CHANGE,
    }),
    toggleAll: (width, height) => {
        const view = getView(width);
        const collapsed = view !== 'DesktopView';
        const isPC = getIsPC(width);
        return {
            type: actions.TOGGLE_ALL,
            collapsed,
            view,
            height,
            isPC,
        };
    },
    toggleOpenDrawer: () => ({
        type: actions.COLLPSE_OPEN_DRAWER,
    }),
    changeOpenKeys: openKeys => ({
        type: actions.CHANGE_OPEN_KEYS,
        openKeys,
    }),
    changeCurrent: current => ({
        type: actions.CHANGE_CURRENT,
        current,
    }),
    clearMenu: () => ({type: actions.CLEAR_MENU}),
    setViewMode: (viewMode) => ({
        type: actions.SET_VIEW_MODE,
        viewMode,
    }),
};
export default actions;
